import { cloudFunction } from 'services/parse';

export const createHomePageCollection = (data: Record<string, any>) => {
  return cloudFunction('createHomePageCollection', data);
};

export const updateHomePageCollection = (data: Record<string, any>) => {
  return cloudFunction('updateHomePageCollection', data);
};

export const deleteHomePageCollection = (id: string) => {
  return cloudFunction('deleteHomePageCollection', { id });
};

export const toggleActiveStatusForHomePageCollection = (id: string) => {
  return cloudFunction('toggleActiveStatusForHomePageCollection', { id });
};

export const fetchHomePageCollection = async () => {
  const response = await cloudFunction('fetchHomePageCollection', {});
  return response.map(item => item.toJSON());
};

export const getHomePageCollectionDetail = (id: string) => {
  return cloudFunction('getHomePageCollectionDetail', { id });
};